<template>
  <div>
    <div class="member-info clearfix">
      <base-img class="img" :src="imageUrl" errType="headImg" width="100px"/>
      <div class="desc">
        <div>姓名：{{info.name}}<span style="margin-left: 30px;">性别：{{info.sex==='1'?'男':'女'}}</span></div>
        <div>出生日期：{{info.birthday}}</div>
        <div>会员卡号：{{info.memberNo}}<span style="margin-left: 30px;">联系方式：{{info.phone}}</span></div>
        <div>居住地址：{{info.province}}{{info.city}}{{info.county}}{{info.addr}}</div>
        <div>备注：{{info.remark}}</div>
      </div>
      <div class="charge">
        <div class="title">账户余额</div>
        <div class="content clearfix">
          <div>
            <div class="info">剩余金额</div>
            <div class="money"><span>{{info.balanceMoney}}</span>元</div>
          </div>
          <div>
            <div class="info">剩余次数</div>
            <div class="money"><span style="color: #73b84e;">{{info.balanceNum}}</span>次</div>
          </div>
        </div>
        <a class="pointer" @click="$router.push({name:'MemberRechargeManagement',params:{memberId:memberId}})">账户充值</a>
      </div>
    </div>
    <base-tab :tabs="tabsData" @tab-click="tabSelected"></base-tab>
    <keep-alive>
      <component :is="logComponent"
                 :memberId="memberId"
                 ref="memberDetail">
      </component>
    </keep-alive>
  </div>
</template>

<script>
import {member} from '../../api'
import LogServe from './LogServe'
import LogVisit from './LogVisit'
import LogRecharge from './LogRecharge'
import LogCharge from './LogCharge'

export default {
  name: 'MemberDetail',
  props: {
    memberId: String
  },
  mounted () {
    this.getMemberDetailData()
  },
  components: {
    'log-serve': LogServe,
    'log-visit': LogVisit,
    'log-recharge': LogRecharge,
    'log-charge': LogCharge
  },
  data () {
    return {
      loading: false,
      tabsIndex: 'serve',
      sexFlag: [{
        id: '1', name: '男'
      }, {
        id: '0', name: '女'
      }],
      logComponent: 'log-serve',
      tabsData: [{
        id: 'serve',
        name: '服务记录',
        badge: ''
      }, {
        id: 'visit',
        name: '回访记录',
        badge: ''
      }, {
        id: 'recharge',
        name: '充值记录',
        badge: ''
      }, {
        id: 'charge',
        name: '消费记录',
        badge: ''
      }],
      imageUrl: '',
      info: {
        name: '',
        phone: '',
        headImg: '',
        sex: '',
        memberNo: '',
        birthday: '',
        province: '',
        city: '',
        county: '',
        addr: '',
        balanceMoney: '',
        balanceNum: '',
        remark: ''
      }
    }
  },
  methods: {
    tabSelected (tab) {
      this.tabsIndex = this.tabsData[tab.index].id
      this.logComponent = 'log-' + this.tabsIndex
    },
    async getMemberDetailData () {
      this.loading = true
      let {data} = await member.getMemberDetailData(this.memberId)
      this.loading = false
      if (data.headImg) {
        this.imageUrl = process.env.VUE_APP_IMG + data.headImg
      }
      this.info = data
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
  .member-info, .member-info * {
    box-sizing: border-box;
  }
  .clearfix {
    display: block;
  }
  .clearfix:after {
    content: '';
    overflow: hidden;
    width: 100%;
    height: 0;
    font-size: 0;
    display: block;
    clear: both;
  }
  .member-info {
    width: 100%;
    background-color: #fff;
    padding: 10px 25px;
    margin-bottom: 10px;
  }
  .member-info>* {
    float: left;
  }
  .member-info img {
    width: 60px;
    height: 60px;
    display: block;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 48px;
  }
  .member-info .desc {
    font-size: 14px;
    color: #777;
    line-height: 18px;
    width: 352px;
    margin-right: 100px;
  }
  .member-info .desc div {
    padding: 7px 0;
  }
  .member-info .charge {
    width: 282px;
    border: 1px solid #dfe1e7;
    color: #666;
  }
  .member-info .charge .title {
    font-size: 14px;
    line-height: 18px;
    padding: 18px 20px 14px;
  }
  .member-info .clearfix {
    padding: 0 20px;
  }
  .member-info .charge .clearfix>div {
    float: left;
    text-align: right;
    width: 33%;
  }
  .member-info .charge .clearfix>div:first-of-type {
    width: 67%;
    text-align: left;
  }
  .member-info .charge .info {
    font-size: 12px;
    color: #777;
  }
  .member-info .charge .money {
    padding: 8px 0 12px;
  }
  .member-info .charge .money span {
    font-size: 18px;
    color: #666;
    margin-right: 8px;
  }
  .member-info .charge a {
    display: block;
    line-height: 40px;
    background-color: #f5f8fa;
    text-align: center;
    font-size: 15px;
    color: #777;
    border-top: 1px solid #dfe1e7;
  }
  .pointer:hover {
    cursor: pointer;
  }
</style>
